export default __webpack_public_path__ + "static/media/clouds1.e73c3147.jpg";